module.exports = __webpack_public_path__ + "static/media/dsr_about1.5effc152.svg";